"use strict";
/* eslint-disable no-underscore-dangle */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleEditor = void 0;
const common_1 = require("@angular/common");
const core_1 = require("@angular/core");
const sales_api_service_1 = require("../../../shared/api/sales-api.service");
const config_service_1 = require("../../../shared/config/config.service");
const interface_service_1 = require("../../../shared/interface/interface.service");
const users_service_1 = require("../../../shared/users/users.service");
const toast_service_1 = require("../../../ui-components/toast/toast.service");
const enums_1 = require("../@shared-types/config/enums");
const enums_2 = require("../@shared-types/vehicle/enums");
const vehicle_1 = require("../shared/models/vehicle/vehicle");
const country_codes_1 = require("../shared/services/country-codes");
const form_tools_service_1 = require("../shared/services/form-tools.service");
const object_1 = __importDefault(require("../shared/services/object"));
const enums_3 = require("../@types/enums");
let VehicleEditor = class VehicleEditor {
    constructor(vehicleModel, configService, toastService, objectService, salesApiService, location, formToolsService, usersService, interfaceService) {
        this.vehicleModel = vehicleModel;
        this.configService = configService;
        this.toastService = toastService;
        this.objectService = objectService;
        this.salesApiService = salesApiService;
        this.location = location;
        this.formToolsService = formToolsService;
        this.usersService = usersService;
        this.interfaceService = interfaceService;
        this.vehicle = null;
        this.activeSection = 'features';
        this.selectOptions = {};
        this.twoStepDelete = false;
        this.newDataCheck = false;
        this.lockEndTime = null;
        this.apiModelDataSending = false;
        this.sending = false;
        /** Updates a datacheck when saving for current user. Only when previous data check is present. */
        this.dataCheckMandatory = false;
        /** Show a success box, if for example a DAT import was sucessful */
        this.successBox = null;
        this.currentFormStep = 'vehicle';
        this.initVehicle = (vehicleId) => __awaiter(this, void 0, void 0, function* () {
            if (this.mode === 'EDIT' && vehicleId) {
                this.vehicle = yield this.vehicleModel.get(vehicleId);
                /** Remove data which we will not modify */
                delete this.vehicle.apiData;
                yield this.lockVehicle(String(this.vehicle._id));
                return;
            }
            this.vehicle = this.vehicleModel.newVehicle();
            this.vehicle.vehicleData.inventory.state = enums_2.EInventoryState.Stock;
            const { vin } = this.configService.getRouteParams();
            if (vin)
                this.vehicle.vin = vin;
        });
        this.prepareVehicle = (vehicle) => {
            var _a;
            const clonedVehicle = this.objectService.deepCopy(vehicle);
            this.formToolsService.traverseAndTransform(clonedVehicle, [
                { key: 'orderNumber', type: 'STRING' },
                { key: 'manufacturerCode', type: 'STRING' },
                { key: 'code', type: 'STRING' },
                { key: 'productionState', type: 'STRING' },
                { key: 'model', type: 'STRING' },
                { key: 'vatRate', type: 'FLOAT' },
                { key: 'key', type: 'STRING' },
                { key: 'hsn', type: 'STRING' },
                { key: 'sellerId', type: 'STRING' },
                { key: 'total', type: 'INTEGER' },
                { key: 'countOwner', type: 'INTEGER' },
            ]);
            if ((this.newDataCheck) || (((_a = this.vehicle) === null || _a === void 0 ? void 0 : _a.dataCheck) && this.dataCheckMandatory)) {
                clonedVehicle.dataCheck = {
                    user: this.usersService.currentUserId(),
                    date: new Date(),
                };
            }
            return clonedVehicle;
        };
        /** Saves the changes for the current vehicle. */
        this.editVehicle = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.vehicle) {
                this.sending = false;
                return;
            }
            if ((_a = this.vehicle.importResult) === null || _a === void 0 ? void 0 : _a.nonDecodedSpecs) {
                this.vehicle.importResult.nonDecodedSpecs = null;
            }
            this.vehicleModel.put(this.prepareVehicle(this.vehicle))
                .then(() => {
                var _a;
                this.sending = false;
                this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'Fahrzeug gespeichert');
                this.location.go(`/vehicles/stock?id=${String((_a = this.vehicle) === null || _a === void 0 ? void 0 : _a._id)}`);
            })
                .catch((e) => this.toastService.error(e));
        });
        /** Adds a new vehicle. */
        this.addVehicle = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.vehicle) {
                this.sending = false;
                return;
            }
            this.vehicleModel.post(this.prepareVehicle(this.vehicle))
                .then((vehicleId) => {
                this.sending = false;
                this.interfaceService.navigateToUrl('/vehicles/stock', { id: vehicleId });
                this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'Fahrzeug gespeichert');
            })
                .catch((e) => this.toastService.error(e));
        });
        this.deleteVehicle = () => {
            if (!this.vehicle)
                return;
            this.vehicleModel.delete(String(this.vehicle._id))
                .then(() => {
                this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'Fahrzeug wurde gelöscht');
                this.interfaceService.navigateToUrl('/vehicles/stock');
            })
                .catch(() => {
                this.toastService.toast(toast_service_1.ToastType.ERROR, 'Fehler beim Löschen des Fahrzeugs');
            });
        };
        this.lockVehicle = (vehicleId) => this.salesApiService.postVehicleLock({
            reason: enums_3.EVehicleFormActions.EDIT,
            user: this.usersService.currentUserId(),
            vehicleId,
            lockTime: 60,
        })
            .then((lock) => {
            this.lockEndTime = lock.endTime;
            return lock;
        })
            .catch((e) => {
            this.toastService.toast(toast_service_1.ToastType.ERROR, 'Fehler beim Sperren des Datensatzes');
        });
        // ! Implement before leave route change for this
        // private removeLock = (): Promise<void> => {
        //   const vehicleId = this.vehicle?._id;
        //   if (!vehicleId) return Promise.resolve();
        //   return this.salesApiService.deleteVehicleLock(vehicleId.toString());
        // };
        this.formSubmission = () => {
            this.sending = true;
            if (this.mode === 'EDIT')
                return this.editVehicle();
            return this.addVehicle();
        };
        this.selectSection = () => {
            const mainElement = document.querySelector('main.main');
            if (!mainElement)
                return;
            mainElement.scrollTop = 0;
        };
        this.showSection = (sectionName) => {
            if (this.activeSection === sectionName) {
                this.activeSection = '';
                return;
            }
            this.activeSection = sectionName;
        };
        /** Retrieve the detailed modelData for an existing vehicle
         * by querying an external API and merging the data into the vehicle. */
        this.getModelDataFromAPI = (apiIdentifier) => __awaiter(this, void 0, void 0, function* () {
            var _b;
            if (!this.vehicle)
                return;
            if (!((_b = this.vehicle) === null || _b === void 0 ? void 0 : _b.vin)) {
                this.toastService.toast(toast_service_1.ToastType.ERROR, 'Für die Abfrage wird die Fahrgestellnummer des Fahrzeugs benötigt');
                return;
            }
            this.vehicle.overwriteProtection = true;
            this.apiModelDataSending = true;
            this.salesApiService
                .getModelDataFromAPI(apiIdentifier, this.vehicle.vin)
                .then((modelData) => {
                if (!this.vehicle || !this.vehicle.modelData)
                    return;
                const usableData = {
                    assistance: modelData.assistance,
                    comfort: modelData.comfort,
                    infotainment: modelData.infotainment,
                    packets: modelData.packets,
                    safety: modelData.safety,
                    sport: modelData.sport,
                    engine: modelData.engine,
                    generalDetails: modelData.generalDetails,
                    features: modelData.features,
                };
                this.objectService.mergeObjects(this.vehicle.modelData, usableData);
                this.apiModelDataSending = false;
                this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'Die detallierte Ausstattung wurde ergänzt.');
            })
                .catch(() => {
                this.apiModelDataSending = false;
            });
        });
        this.getModelDataFromBodycode = () => __awaiter(this, void 0, void 0, function* () {
            var _c;
            if (!this.vehicle)
                return;
            if (!((_c = this.vehicle) === null || _c === void 0 ? void 0 : _c.bodycode)) {
                this.toastService.toast(toast_service_1.ToastType.ERROR, 'Für die Abfrage wird der Bodycode des Fahrzeugs benötigt');
                return;
            }
            this.apiModelDataSending = true;
            this.salesApiService
                .getBodycode({ bodycode: this.vehicle.bodycode })
                .then((bodycode) => {
                if (!this.vehicle || !this.vehicle.modelData)
                    return;
                this.objectService.mergeObjects(this.vehicle.modelData, bodycode);
                /** Add emissions */
                if (bodycode.emissions) {
                    this.vehicle.vehicleData.emissions = bodycode.emissions;
                }
                this.apiModelDataSending = false;
                this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'Die Ausstattung wurde ergänzt.');
            })
                .catch(() => {
                this.toastService.toast(toast_service_1.ToastType.ERROR, 'Kein Bodycode gefunden.');
                this.apiModelDataSending = false;
            });
        });
        /** Used to track array of strings */
        this.trackSelectables = (index) => index;
        const { vehicleId } = this.configService.getRouteParams();
        const { success } = this.configService.getRouteParams();
        this.mode = vehicleId ? 'EDIT' : 'NEW';
        this.initVehicle(vehicleId);
        if (success === 'dat')
            this.successBox = 'DAT Import erfolgreich!';
        if (success === 'schwacke')
            this.successBox = 'Schwacke Import erfolgreich!';
        if (success === 'reactivation')
            this.successBox = 'Fahrzeug erfolgreich reaktiviert!';
        if (success === 'us')
            this.successBox = 'US-Import erfolgreich!';
        if (success === 'loco-soft')
            this.successBox = 'Loco-Soft Import erfolgreich!';
        this.selectOptions = {
            vehicleClass: this.configService.getConstant(config_service_1.ConstantTypes.VEHICLE_CLASS),
            vehicleCategory: this.configService.getConstant(config_service_1.ConstantTypes.VEHICLE_CATEGORY),
            vehicleManufacturer: this.configService.getConstant(config_service_1.ConstantTypes.VEHICLE_MANUFACTURER),
            fuelTypes: this.configService.getConstant(config_service_1.ConstantTypes.FUEL_TYPES),
            drivetrainTypes: this.configService.getConstant(config_service_1.ConstantTypes.DRIVETRAIN_TYPES),
            transmissionTypes: this.configService.getConstant(config_service_1.ConstantTypes.TRANSMISSION_TYPES),
            efficiencyClass: this.configService.getConstant(config_service_1.ConstantTypes.EFFICIENCY_CLASS),
            emissionClass: this.configService.getConstant(config_service_1.ConstantTypes.EMISSION_CLASS),
            inventoryStates: this.configService.getConstant(config_service_1.ConstantTypes.INVENTORY_STATE),
            exteriorColorName: this.configService.getConstant(config_service_1.ConstantTypes.EXTERIOR_COLOR_NAME),
            interiorColorName: this.configService.getConstant(config_service_1.ConstantTypes.INTERIOR_COLOR_NAME),
            interiorType: this.configService.getConstant(config_service_1.ConstantTypes.INTERIOR_TYPE),
            speedControl: this.configService.getConstant(config_service_1.ConstantTypes.SPEED_CONTROL),
            climatization: this.configService.getConstant(config_service_1.ConstantTypes.CLIMATIZATION),
            radioTypes: this.configService.getConstant(config_service_1.ConstantTypes.RADIO_TYPES),
            daytimeRunningLights: this.configService.getConstant(config_service_1.ConstantTypes.DAYTIMERUNNING_LIGHTS),
            headlightTypes: this.configService.getConstant(config_service_1.ConstantTypes.HEADLIGHT_TYPES),
            bendingHeadlights: this.configService.getConstant(config_service_1.ConstantTypes.BENDING_HEADLIGHTS),
            airbags: this.configService.getConstant(config_service_1.ConstantTypes.AIRBAGS),
            countryCodes: country_codes_1.iso3166Code2,
        };
        this.dataCheckMandatory = this.configService.get(enums_1.EConstantType.DATA_CHECK_MANDATORY) || false;
    }
};
VehicleEditor = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-editor',
        templateUrl: require('./vehicle-editor.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _a : Object, typeof (_b = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _b : Object, typeof (_c = typeof toast_service_1.ToastService !== "undefined" && toast_service_1.ToastService) === "function" ? _c : Object, typeof (_d = typeof object_1.default !== "undefined" && object_1.default) === "function" ? _d : Object, typeof (_e = typeof sales_api_service_1.SalesAPIService !== "undefined" && sales_api_service_1.SalesAPIService) === "function" ? _e : Object, typeof (_f = typeof common_1.Location !== "undefined" && common_1.Location) === "function" ? _f : Object, typeof (_g = typeof form_tools_service_1.FormToolsService !== "undefined" && form_tools_service_1.FormToolsService) === "function" ? _g : Object, typeof (_h = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _h : Object, typeof (_j = typeof interface_service_1.InterfaceService !== "undefined" && interface_service_1.InterfaceService) === "function" ? _j : Object])
], VehicleEditor);
exports.VehicleEditor = VehicleEditor;
